import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import * as AiIcons from "react-icons/ai";
import { Button } from 'react-bootstrap';
import { FaEdit } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'5%'}}>Item ID</th>
        <th style={{width:'10%'}}>Part Number</th>
        <th style={{width:'20%'}}>Description</th>
        <th style={{width:'10%'}}>Finish Cabinet Box Case</th>
        <th style={{width:'10%'}}>Finish Cabinet Door</th>
        <th style={{width:'10%'}}>Door Material</th>
        <th style={{width:'10%'}}>EB Material</th>
        <th className='d-none d-sm-table-cell'>Primary Unit of Measure</th>
        <th>Material Cost</th>
        <th style={{width:'5%'}}>{props.mode==0?'Edit':''}</th>
      </tr>
    </thead>
  )
}

// Format the price above to USD using the locale, style, and currency.
let USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const TableBody = (props) => {
  if (props.itemsObj) {
    const rows = props.itemsObj.map((row, index) => { 
      if (row.item) {
        var rowitem = row.item;
      }      
      else {
        var rowitem = row;
      }
      return (      
        <tr key={index}>        
          <td style={{width:'5%'}}>
            {rowitem.id}
          </td>        
          <td style={{width:'10%'}}>
            {rowitem.itempartnumber}
          </td>
          <td>  
            {rowitem.itemdescription}
          </td>
          <td style={{textAlign:'center'}}>  
            {rowitem.finish_cabinet_box_case===1?<FaCheckCircle color='green'/>:<IoMdCloseCircle color='#9C0006'/>}
          </td>  
          <td style={{textAlign:'center'}}>  
            {rowitem.finish_cabinet_door===1?<FaCheckCircle color='green'/>:<IoMdCloseCircle color='#9C0006'/>}
          </td>   
          <td style={{textAlign:'center'}}>  
            {rowitem.doormaterial===1?<FaCheckCircle color='green'/>:<IoMdCloseCircle color='#9C0006'/>}
          </td>        
          <td style={{textAlign:'center'}}>  
            {rowitem.ebmaterial===1?<FaCheckCircle color='green'/>:<IoMdCloseCircle color='#9C0006'/>}
          </td>                                        
          <td className='d-none d-sm-table-cell'>  
            {rowitem.primaryuom?rowitem.primaryuom.unitofmeasureabbrev:null}
          </td>        
          <td align='right'>  
            {USDollar.format(rowitem.standardsellingunitprice)}
          </td>   
          <td align='center'>  
            {(props.mode==0) &&
              <Button>
                <Link to = {`/edititempage/${row.id}`}><FaEdit color='white'/></Link>  
              </Button>
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                if (props.filterbymovementnumber) {
                  props.populateRequestQties(row);
                }                  
                props.onSelected(rowitem.id,rowitem.itemdescription,rowitem.primaryuom.unitofmeasureabbrev,rowitem.standardpurchaseunitprice,rowitem.itempartnumber,rowitem.primaryuom.id);
                props.handleClose();
              }} variant='link' value={rowitem.id}>Select</Button>
            } 
          </td>              
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}


const ItemsList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />
            <TableBody filterbymovementnumber={props.filterbymovementnumber} handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} itemsObj={props.listOfItems} populateRequestQties={props.populateRequestQties}/>
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default ItemsList;